<template>
  <div class="cate-activities goods-category">
    <div class="scrolltab-container" :style="{ height: winHeight + 'px' }">
      <div class="scroll-tabs" v-if="showTabs">
        <div class="scroll-tab">
          <div
            class="scroll-tab-item"
            v-for="(cate, index) in children"
            :key="index"
            :class="cate.id === cateId ? 'active' : ''"
            @click="switchTab(cate.id)"
          >
            <label>{{ cate.cate_name }}</label>
          </div>
        </div>
      </div>
      <template v-if="showTopNavigation">
        <div
          class="category-content fixed-content"
          ref="fixedContent"
          v-if="otherType === 'time'"
        >
          <div class="category-item-list pull-left">
            <router-link
              class="category-item-link"
              :to="{
                name: 'CityActivities',
                query: {
                  cate_id: '',
                  type: 'other',
                  other_type: 'time',
                  days: 1
                }
              }"
              :class="{ 'category-actitity': days == 1 }"
            >
              <div class="category-item-img-wrapper">
                <img
                  class="category-item-img"
                  src="../../assets/images/day1_5.png"
                />
              </div>
              <div class="category-item-title">1天</div>
            </router-link>
          </div>
          <div class="category-item-list pull-left">
            <router-link
              class="category-item-link"
              :to="{
                name: 'CityActivities',
                query: {
                  cate_id: '',
                  type: 'other',
                  other_type: 'time',
                  days: 2
                }
              }"
              :class="{ 'category-actitity': days == 2 }"
            >
              <div class="category-item-img-wrapper">
                <img
                  class="category-item-img"
                  src="../../assets/images/day2_5.png"
                />
              </div>
              <div class="category-item-title">2天</div>
            </router-link>
          </div>
          <div class="category-item-list pull-left">
            <router-link
              class="category-item-link"
              :to="{
                name: 'CityActivities',
                query: {
                  cate_id: '',
                  type: 'other',
                  other_type: 'time',
                  days: 3
                }
              }"
              :class="{ 'category-actitity': days == 3 }"
            >
              <div class="category-item-img-wrapper">
                <img
                  class="category-item-img"
                  src="../../assets/images/day3_5.png"
                />
              </div>
              <div class="category-item-title">3天</div>
            </router-link>
          </div>
          <div class="category-item-list pull-left">
            <router-link
              class="category-item-link"
              :to="{
                name: 'CityActivities',
                query: {
                  cate_id: '',
                  type: 'other',
                  other_type: 'time',
                  days: 6
                }
              }"
              :class="{ 'category-actitity': days == 6 }"
            >
              <div class="category-item-img-wrapper">
                <img
                  class="category-item-img"
                  src="../../assets/images/day4_5.png"
                />
              </div>
              <div class="category-item-title">4~6天</div>
            </router-link>
          </div>
          <div class="category-item-list pull-left">
            <router-link
              class="category-item-link"
              :to="{
                name: 'CityActivities',
                query: {
                  cate_id: '',
                  type: 'other',
                  other_type: 'time',
                  days: 7
                }
              }"
              :class="{ 'category-actitity': days == 7 }"
            >
              <div class="category-item-img-wrapper">
                <img
                  class="category-item-img"
                  src="../../assets/images/day5_5.png"
                />
              </div>
              <div class="category-item-title">7天以上</div>
            </router-link>
          </div>
          <div class="clearfix"></div>
        </div>
        <div class="category-content fixed-content" ref="fixedContent" v-else>
          <div
            class="category-item-list pull-left"
            v-for="(children, cindex) in category"
            :key="cindex"
            :class="{ 'category-actitity': children.id == cateId }"
          >
            <router-link
              class="category-item-link"
              :to="{
                name: 'CityActivities',
                query: { cate_id: children.id, type: 'other', other_type: '' }
              }"
            >
              <div class="category-item-img-wrapper">
                <img class="category-item-img" v-lazy="children.pic" />
              </div>
              <div class="category-item-title">{{ children.cate_name }}</div>
            </router-link>
          </div>
          <div class="clearfix"></div>
        </div>
      </template>
      <div class="scroll-content" :class="{ pdl: showTabs }">
        <div class="scroll-content-body" @scroll="handleScroll">
          <div
            class="activity-item-holder"
            :style="{ height: holderHeight + 'px' }"
          ></div>
          <div class="no-more-data" v-if="loadend && activityData.length === 0">
            暂无数据
          </div>
          <div
            class="activity-item"
            v-for="(activity, index) in activityData"
            :key="index"
          >
            <router-link
              class="activity-link"
              :to="{
                name: 'ActivityDetails',
                query: {
                  id: activity.id,
                  city_id: activity.start_city.split(',')[0]
                }
              }"
            >
              <div
                class="activity-base"
                :class="{ 'activity-base144': showTabs }"
              >
                <img
                  class="activity-img"
                  v-lazy="activity.image + '?x-oss-process=image/resize,w_520'"
                />
                <div class="activity-day" v-if="activity.day > 0">
                  {{ activity.day }}天
                </div>
                <div class="activity-price">{{ activity.price }}元</div>
              </div>
              <div class="activit-name">{{ activity.store_name }}</div>
              <div class="activity-info" v-if="activity.date_list.length > 0">
                出发日期:
                <template v-for="(date, dindex) in activity.date_list">
                  {{ date.departure_date }}
                  <template v-if="dindex < activity.date_list.length - 1">
                    ,
                  </template>
                </template>
              </div>
            </router-link>
          </div>
          <div
            class="loading-box"
            :class="{
              transparent: loading === false
            }"
          >
            <div class="content-loading">
              <i class="loading-indicator"></i>
              <span class="loading-text">加载中...</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getClassActivities } from "@api/activity";
import { getActivityCategory } from "@api/store";
import debounce from "lodash.debounce";

export default {
  data() {
    return {
      cateId: "",
      children: [],
      winHeight: "",
      loading: false,
      loadend: false,
      activityData: [],
      activities: {},
      page: 1,
      limit: 10,
      category: [],
      jingwai: [],
      jingnei: [],
      type: "jingnei",
      showTabs: true,
      showTopNavigation: false,
      parentId: "",
      allCategory: [],
      otherType: "",
      holderHeight: "",
      days: "",
      currentRes: {}
    };
  },
  components: {},
  watch: {
    $route() {
      let that = this;
      that.loadend = false;
      that.activityData = [];
      that.loading = true;
      that.initFirst();
      that.initResource(that.currentRes);
      that.$nextTick(() => {
        that.loading = false;
      });
    }
  },
  mounted: function() {
    let that = this;
    that.initFirst();
    getActivityCategory()
      .then(res => {
        that.initResource(res);
      })
      .catch(this.$dialog.loading.close());
  },
  methods: {
    initFirst() {
      let that = this;
      that.$set(that, "winHeight", window.innerHeight);
      that.$set(that, "type", that.$route.query.type);
      that.$set(that, "otherType", that.$route.query.other_type);
      that.$set(that, "days", that.$route.query.days);
    },
    initResource(res) {
      let that = this;
      that.$set(that, "currentRes", res);
      that.$set(that, "allCategory", res.data.other);
      that.$set(that, "jingnei", res.data.destination[0]);
      that.$set(that, "jingwai", res.data.destination[1]);
      let children = [];
      if (that.type === "jingnei") {
        children = that.jingnei.children;
        that.$set(that, "showTopNavigation", false);
        that.$set(that, "showTabs", true);
      } else if (that.type === "jingwai") {
        children = that.jingwai.children;
        that.$set(that, "showTabs", true);
      } else if (that.type == "other") {
        that.$set(that, "showTabs", false);
        that.$set(that, "showTopNavigation", true);
        if (that.otherType !== "time") {
          const categoryData = res.data.other.filter(
            item => item.id === parseInt(that.$route.query.parent_id)
          );
          if (categoryData.length > 0) {
            that.$set(that, "category", categoryData[0].children);
          }
        }
        that.$nextTick(() => {
          if (that.showTopNavigation && that.$refs.fixedContent) {
            that.$set(
              that,
              "holderHeight",
              that.$refs.fixedContent.offsetHeight
            );
          }
        });
      }
      if (that.type == "other" && that.otherType === "time") {
        that.page = 1;
        that.loadend = false;
        this.getProductList();
      } else {
        if (!that.$route.query.cate_id) {
          if (children && children.length > 0) {
            that.switchTab(children[0].id);
          }
        } else {
          that.switchTab(parseInt(that.$route.query.cate_id));
        }
      }
      that.$set(that, "children", children);
      this.$dialog.loading.close();
    },
    handleScroll() {
      !this.loading && this.getProductList();
    },
    switchTab(cateId) {
      let that = this;
      if (cateId !== parseInt(this.$route.query.cate_id)) {
        this.$router.replace({
          name: "CityActivities",
          query: {
            cate_id: cateId,
            type: that.type,
            other_type: that.otherType
          }
        });
      }
      that.cateId = cateId;
      that.page = 1;
      that.loadend = false;
      that.$set(that, "cateId", cateId);
      that.$set(that, "activityData", []);
      this.getProductList();
    },
    getProductList: debounce(function() {
      let that = this;
      if (that.loading) return; //阻止下次请求（false可以进行请求）；
      if (that.loadend) return; //阻止结束当前请求（false可以进行请求）；
      const cateId = this.cateId;
      that.$set(that, "loading", true);
      let params = {};
      if (that.type === "jingnei") {
        params = {
          cate_id: cateId,
          page: that.page
        };
      } else if (that.type === "jingwai") {
        params = {
          cate_id: cateId,
          page: that.page
        };
      } else if (that.type == "other") {
        if (that.otherType === "time") {
          params = {
            days: that.days,
            page: that.page
          };
        } else {
          params = {
            cate_id: cateId,
            page: that.page
          };
        }
      }
      getClassActivities(params)
        .then(res => {
          that.$set(that, "loading", false);
          let array = res.data;
          const flags = {};
          array = that.activityData.concat(array);
          const unique = array.filter(function(entry) {
            if (flags[entry.id]) {
              return false;
            }
            flags[entry.id] = true;
            return true;
          });
          that.activityData = unique;
          that.loadend = res.data.length < that.limit; //判断所有数据是否加载完成；
          that.page = that.page + 1;
        })
        .catch(err => {
          that.$set(that, "loading", false);
          console.log(err);
        });
    }, 300)
  }
};
</script>
